import React from 'react';
import { Suspense } from 'react';
import Header from './Header';
import { Footer } from './LazyComponents';
import { useTheme } from '../contexts/ThemeContext';

interface PageLayoutProps {
  children: React.ReactNode;
  /** Extra top padding for pages without a full-bleed hero */
  withTopPadding?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, withTopPadding = true }) => {
  const { themeClasses } = useTheme();

  if (!themeClasses) {
    return <div className="min-h-screen bg-terminal-black text-teal-400">Loading...</div>;
  }

  return (
    <>
      <Header />
      <main className={withTopPadding ? 'pt-20 sm:pt-24' : undefined}>{children}</main>
      <Suspense
        fallback={
          <div
            className={`h-32 ${themeClasses.bg}/80 animate-pulse border-t ${themeClasses.border}/20`}
          />
        }
      >
        <Footer />
      </Suspense>
    </>
  );
};

export default PageLayout;
